<template>
	<div class="address" :class="classes">
		<div class="address__title">
			<h4 class="body-2 font-weight-bold secondary--text">{{title}}</h4>
			<slot name="address-actions"></slot>
		</div>

		<span class="font-weight-bold address__line" v-if="company">{{company}}</span>

		<span class="address__line" v-if="address">{{address}}</span>

		<span class="address__line" v-if="cityStateZip">{{cityStateZip}}</span>

		<br v-if="(company || address || cityStateZip) && (name || email || phoneNumber)" />

		<span class="address__line font-weight-bold" v-if="name">{{name}}</span>

		<span class="address__line" v-if="email">{{email}}</span>

		<span class="address__line" v-if="phoneNumber">{{phoneNumber | phone}}</span>
	</div>
</template>

<script>
export default {
	name: "address-display",

	data() {
		return {};
	},

	props: {
		title: {
			default: ""
		},

		object: {
			default() {
				return {};
			}
		},

		prefix: {
			default: ""
		},

		classes: {
			default: ""
		}
	},

	computed: {
		company() {
			return this.getObjectValue(`${this.prefix}company`, this.object);
		},

		address() {
			return this.getObjectValue(`${this.prefix}address`, this.object);
		},

		cityStateZip() {
			let cityStateZip = "";

			if (this.getObjectValue(`${this.prefix}city`, this.object)) {
				cityStateZip +=
					this.getObjectValue(`${this.prefix}city`, this.object) +
					", ";
			}

			if (this.getObjectValue(`${this.prefix}state`, this.object)) {
				cityStateZip +=
					this.getObjectValue(`${this.prefix}state`, this.object) +
					" ";
			}

			if (this.getObjectValue(`${this.prefix}zip`, this.object)) {
				cityStateZip += this.getObjectValue(
					`${this.prefix}zip`,
					this.object
				);
			}

			return cityStateZip;
		},

		name() {
			return this.getObjectValue(`${this.prefix}name`, this.object);
		},

		email() {
			return this.getObjectValue(`${this.prefix}email`, this.object);
		},

		phoneNumber() {
			return this.getObjectValue(
				`${this.prefix}phone`,
				this.object,
				this.getObjectValue(
					`${this.prefix}cell_phone`,
					this.document,
					""
				)
			);
		}
	}
};
</script>
